export var RadioType = require("./radio/radio").default;
export var RadioGroupType = require("./radio/radio-group").default;
export var CheckboxType = require("./checkbox-tag").default;
export var AddressMapType = require("./address/address-map").default;
export var AddressType = require("./address/address").default;
export var TimeInputType = require("./time/index").default;
export var DndListType = require("./dnd-list").default;
export var MultiAddressList = require("./multi-address-list").default;
export var DocumentsOfficials = require("./documents_official").default;
export var DocumentsOfficialsOD = require("./documents_official_od").default;
export var CommunitySiteAddress = require("./address/community-site").default;
export var TextAreaType = require("./textarea").default;
export var CategorizedResponses = require("./categorized-responses").default;
export var SelectionListStops = require("./selection-list-stops").default;
export var SelectionListLineStops = require("./selection-list-line-stops").default;
export var SelectionJourney = require("./selection-journey").default;
export var SequenceType = require("./sequences/type").default;
export var SequenceResume = require("./sequences/information").default;
export var MapAreaSelection = require("./map/area-selection").default;
export var MapSimple = require("./map/simple").default;
export var Calendar = require("./calendar").default;
export var Select = require("./select").default;
export var Slider = require("./slider").default;
export var SelectionPolygon = require("./selection-list-polygon").default;
export var Email = require("./email").default;
export var Captcha = require("./captcha-anonymous").default;
export var SequenceJourney = require("./sequence-journey").default;
export var Mode = require("./mode").default;
export var TimeClassic = require("./time-classic").default;
export var EmailProInput = require("./email-pro").default;
export var CustomEnds = require("./custom-end").default;

// CONNEXION
// GENRRAL
export var ConnectUser = require("./connect").default;
// SPECIALISEE
export var ConnectTpg = require("./sub-connect/connect-tpg").default;
export default {
  TextAreaType: TextAreaType,
  RadioType: RadioType,
  RadioGroupType: RadioGroupType,
  CheckboxType: CheckboxType,
  AddressType: AddressType,
  TimeInputType: TimeInputType,
  AddressMapType: AddressMapType,
  DndListType: DndListType,
  MultiAddressList: MultiAddressList,
  DocumentsOfficials: DocumentsOfficials,
  DocumentsOfficialsOD: DocumentsOfficialsOD,
  CommunitySiteAddress: CommunitySiteAddress,
  ConnectUser: ConnectUser,
  CategorizedResponses: CategorizedResponses,
  SequenceType: SequenceType,
  SequenceResume: SequenceResume,
  SelectionListStops: SelectionListStops,
  MapAreaSelection: MapAreaSelection,
  SelectionJourney: SelectionJourney,
  Calendar: Calendar,
  SelectionListLineStops: SelectionListLineStops,
  Select: Select,
  MapSimple: MapSimple,
  Slider: Slider,
  SelectionPolygon: SelectionPolygon,
  Email: Email,
  SequenceJourney: SequenceJourney,
  Captcha: Captcha,
  EmailProInput: EmailProInput,
  CustomEnds: CustomEnds,
  //
  ConnectTpg: ConnectTpg,
  TimeClassic: TimeClassic,
  Mode: Mode
};